import { Injectable }    from '@angular/core';
import { environment } from '../../environments/environment';
import { Headers, Http } from '@angular/http';
import { InterceptorService } from 'ng2-interceptors';
import { Observable } from 'rxjs/Observable';
import { Du } from '../entity/du';
import 'rxjs/add/operator/toPromise';


@Injectable()
export class AutoCompleteService {
  private headers = new Headers({'Content-Type': 'application/json'});

  constructor(private http: InterceptorService) { }

  getDus(search): Promise<any> {
    return this.http.post(environment.apiUrl+'site-api/list/du', JSON.stringify({search: search}), {headers: this.headers})
               .toPromise()
               .then(
                  function(response) {
                    let dus = [];
                    let response_obj = response.json();
                    for(let index in response_obj){
                      let du = new Du();
                      du.fromJSON(response_obj[index]);
                      dus[dus.length] = du;
                    }
                    return dus;
                  }
                )
               .catch(this.handleError);
  }


  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/auto-complete.service.ts